import type { Params } from '@vimcar/mvvm/linkViewModel'
import type { Transitioner } from '#components/TransitionProvider'

import * as mobx from 'mobx'
import PT from 'prop-types'

import type { Nodes } from '../../models/Nodes'
import type { ViewState } from '../Root/viewModel'

import {
  ATTRIBUTE_ODOMETER,
  ATTRIBUTE_ODOTIMESTAMP,
} from '../../utils/constants'

export type Props = {
  state: ViewState
}

export type ViewModel = {
  attributeName: string
  odometerValue?: number | null
  isValid: boolean
  isFormValid: boolean
  today?: Date | null
  odometerTimestamp?: Date | null

  handleNext: () => void
  handleBack: () => void
  handleNowClick: () => void
  handleFormValid: (boolean) => void
  handleFormChange: (Object) => void
}

type Context = {
  models: { nodes: Nodes }
  transitioner: Transitioner
}

const mkViewModel = (
  params: Params,
  { state }: Props,
  { transitioner }: Context,
): ViewModel => {
  const vm = mobx.observable({
    odometerValue: null,
    isFormValid: false,
    today: new Date(),
    odometerTimestamp: null,
    get isValid() {
      return !!(vm.isFormValid && vm.odometerTimestamp)
    },

    handleNext: mobx.action(() => {
      state.customAttributes.set(ATTRIBUTE_ODOMETER, vm.odometerValue)
      state.customAttributes.set(ATTRIBUTE_ODOTIMESTAMP, vm.odometerTimestamp)
      if (state.currentNode.nextNode) {
        transitioner.goForward(state.currentNode.nextNode.id)
      }
    }),
    handleBack: mobx.action(() => {
      state.customAttributes.delete(ATTRIBUTE_ODOMETER)
      state.customAttributes.delete(ATTRIBUTE_ODOTIMESTAMP)
    }),
    handleFormValid: mobx.action((isValid) => {
      // @ts-expect-error@2322
      vm.isFormValid = isValid
    }),
    handleFormChange: mobx.action((values) => {
      // @ts-expect-error@2339
      const { odometer } = values
      vm.odometerValue = odometer
    }),
    handleDateChange: mobx.action((value) => {
      // @ts-expect-error@2769
      vm.odometerTimestamp = new Date(value)
    }),
    handleNowClick: mobx.action(() => {
      vm.odometerTimestamp = new Date()
    }),
  })
  // @ts-expect-error@2741
  return vm
}

mkViewModel.contextTypes = {
  models: PT.object.isRequired,
  transitioner: PT.object.isRequired,
}

export default mkViewModel
